'use strict';
const badges = require('../product/badges');

$(document).ready(()=>{
  const productVal = $('#showProductModal').val();
  badges.plpStructureBadgesInRecommender();
  showModalPromoSolar();
  showMCasePromo();
  $(document).on('click', 'button.add-to-cart-promo', function (e) {
            var addToCartUrl;
            var pid;

            pid = e.target.dataset.id;
            addToCartUrl = $('#add-to-cart-url-modal').val();
            var form = {
                pid: pid,
                quantity: 1            
            };

            if (addToCartUrl) {
               $.ajax({
                       url: addToCartUrl,
                       method: 'POST',
                       data: form,
                       success: function (data) {
                        updateQuantityOfCase(data.cart);
                          $('.solar-promo-modal').fadeOut(); 
                           if (data.redirectUrl) {
                               window.location.href = data.redirectUrl;
                           }
                           updateCartTotals(data.cart);
                           showToastMessage(data.error, data.message);
                       },
                       error: function () {
                           $.spinner().stop();
                       }
                   });
            }
        });
  cleanLocalStorage();
  triggerSelectStore();
  var colDesk = parseInt($('#show-solar-col-desk').val());
  var colTablet = parseInt($('#show-solar-col-tablet').val());
  var colMobile = parseInt($('#show-solar-col-mobile').val());
  showCarouselPromo(colDesk,colTablet,colMobile);
  if (productVal){
    $('#productDeliveryTimesModal').modal('show')
  }
  if($('#select-local-store') && $('#select-local-store').data('is-flow-store')) {
    $('#select-local-store').trigger('change');
  }
   $(document).on('click', '.close-solar-modal', function () {
        $('.solar-promo-modal').fadeOut();
    });
    $(document).on('click', 'button.add-to-cart-modal', function (e) {
            var addToCartUrl;
            var pid;
    
            pid = $(this).data('id');
            addToCartUrl = $('#add-to-cart-url-modal').val() || $(this).data('action');
            var form = {
                pid: pid,
                quantity: 1            
            };
    
            if (addToCartUrl) {
               $.ajax({
                       url: addToCartUrl,
                       method: 'POST',
                       data: form,
                       success: function (data) {
                           updateCartTotals(data.cart);
                           showToastMessage(data.error, data.message);
                           if(!data.error){
                               $('.solar-promo-modal').fadeOut();
                               setLocalStorageWithExpiry('showModalTime', true, 24 * 60 * 60 * 1000); 
                               window.location.reload();
                           }
                       },
                       error: function () {
                           $.spinner().stop();
                       }
                   });
            }
        });
});

var base = require('base/product/base');
var focusHelper = require('base/components/focus');
const couponField = $('.coupon-code-field');
const couponMissing = $('.coupon-missing-error');
const promoCodeBtn = $('.promo-code-btn');
const couponError = $('#coupon-error');
const circleWarning = $('.coupon-circle-warning');
const couponErrorMsj = $('.coupon-error-message');
const disabledCustom = $('.disabled-custom');
let promoCodeForm = $('.promo-code-form .form-control');

function updateQuantityOfCase(data) {
var targetPID = $('#id-product-promotion').val();
var $select = $('select.quantity[data-pid="' + targetPID + '"]');
var uuid = $select.data('uuid');
var currentValue = parseInt($select.val(), 10);
var valueQuantity = currentValue +  1;
$('.quantity[data-uuid="' + uuid + '"]').val(valueQuantity);
}
/**
 * Allows to take the value of hidden #show-solar-promo-modal and validate if the modal is shown or not.
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function showModalPromoSolar() {
        const showModalFlag = $('#show-solar-promo-modal').val() === 'true';
        const alreadySeen = getLocalStorageWithExpiry('showModalTime');

        const shouldShow = showModalFlag && alreadySeen;

        if (shouldShow) {
            $('.solar-promo-modal').fadeIn();
            $('.solar-promo-modal').removeClass('d-none');
    }
}
function showMCasePromo(showModalCase) {
        const showModalFlag = $('#show-case-promo').val() === 'true';
        if (showModalFlag || showModalCase) {
            $('.promo-cases-container').fadeIn();
            $('.promo-cases-container').removeClass('d-none');
    }else{
         $('.promo-cases-container').fadeOut();
            $('.promo-cases-container').addClass('d-none');
    }
}
function getLocalStorageWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return true;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return true;
    }

    return false;
}

function setLocalStorageWithExpiry(key, value, ttlInMs) {
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + ttlInMs,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

function showCarouselPromo(colDesk,colTablet,colMobile) {
    const $carousel = $('.solar-carousel');
    if (!$carousel.hasClass('slick-initialized')) {
            $carousel.slick({
                slidesToShow: colDesk,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 992, // Tablet
                        settings: {
                            slidesToShow: colTablet
                        }
                    },
                    {
                        breakpoint: 576, // Mobile
                        settings: {
                            slidesToShow: colMobile
                        }
                    }
                ]
            });
        }
        $('#solarPromoModal').on('shown.bs.modal', function () {
            $carousel.slick('setPosition'); 
        });
}
/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        $('#termsandconditionscart').data('cart-has-error', true);

        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.cart').removeClass('cart-page').addClass('cart-empty');
            $('.cart-header').find('.subtotal-header-container').empty();
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('#termsandconditionscart').data('cart-has-error', false);
        $('.alert-danger').hide();

        if($('.checkout-buttons-container #termsandconditionscart').prop('checked')) {
            $('.checkout-btn').removeClass('disabled');
        }
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.totalWithoutShipment);
    $('.cart-subtotal-header').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.couponsHtml);
            $('.display-discount-container').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        let unitPriceHtml =  `<span data-value="${item.priceUnitCustom.value}">${item.priceUnitCustom.formatted}</span>
            <span class="strike-through strike-dinamyc" data-value="${item.price.list ? item.price.list.value : (item.price.sales.value !== item.priceUnitCustom.value ? item.price.sales.value : '')}">${item.price.list ? item.price.list.formatted : (item.price.sales.value !== item.priceUnitCustom.value ? item.price.sales.formatted: '')}</span>`;

        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(unitPriceHtml);
        if (item.totalPack.value > 0) {
            $('.item-total-' + item.UUID).empty().append(item.priceTotalCustom.renderedPrice);
        } else {
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }

        let prodMainPrice =  `<span>${item.priceTotal.price}</span>
            <span class="strike-through">${item.price.list ? item.price.list.formatted : (item.priceTotal.nonAdjustedPrice ?
                item.priceTotal.nonAdjustedPrice : '')}</span>`;
        $('.product-main-uuid-'+ item.UUID+ ' .sub-element-price').empty().append(prodMainPrice);

        if(item.childProd.length > 0) {
            var childProd = item.childProd;
            childProd.forEach(prod => {
                let spamHtml =  `<span>${prod.priceTotal.price}</span>
                    <span class="strike-through">${prod.price.list ? prod.price.list.formatted :
                        (prod.priceTotal.nonAdjustedPrice ? prod.priceTotal.nonAdjustedPrice : '')}</span>`;
                $('.element-'+ prod.UUID+ ' .sub-element-price').empty().append(spamHtml);
            });
        }
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

$("#termsandconditionscart").prop("checked", false);
$('#termsandconditionscart').data('terms-acceptance', false);
$('body').on('click', '#termsandconditionslabel', function() {
    showSubscriptionsTermsModal();
});

$('body').on('click', '#subscriptionTermsModal .btn-primary', function() {
    acceptSubscriptionModal();
    hideSubscriptionsTermsModal();
});

$('body').on('change', '#termsandconditionscart, #spttermsandconditionscart', function() {
    const $spt = $('#spttermsandconditionscart');
    
    const $currentTarget = $(this)
    const sptAcceptance = $spt && $spt.is(":visible") ? $spt.prop('checked') : true; // In case there is no spt in cart, it is accepted by default
    
    if(sptAcceptance && $currentTarget.attr('id') === 'spttermsandconditionscart'){
        showSPTSModal();
        $spt.prop('checked', false); //should be checked if user accept spt t&c
        return;
    }

    validateTermsAndCondition()
});

function validateTermsAndCondition(){
    const termsAndConditonsCart = $('#termsandconditionscart');
    const acceptance = termsAndConditonsCart.prop('checked');
    const $spt = $('#spttermsandconditionscart');

    const sptAcceptance = $spt && $spt.is(":visible") ? $spt.prop('checked') : true; // In case there is no spt in cart, it is accepted by default

    const dataCartHasError = termsAndConditonsCart.data('cart-has-error');
    const cartHasError = (typeof dataCartHasError !== 'undefined' && dataCartHasError === true);

    if (cartHasError === false && acceptance && sptAcceptance) {
        termsAndConditonsCart.parents('.checkout-continue').find('.checkout-btn').removeClass('disabled');
    } else {
        termsAndConditonsCart.parents('.checkout-continue').find('.checkout-btn').addClass('disabled');
    }
}

function showSPTSModal(){
    $('.spt-terms-modal .modal').modal('show');
}

$('body').on('click', '.spt-terms-modal .modal .confirm', function(){
    const $spt = $('#spttermsandconditionscart')
    $spt.prop('checked', true);
    $('.spt-terms-modal .modal').modal('hide');
    
    validateTermsAndCondition()

    $('body').trigger('spt:acceptTermsAndCondition')
})

function cleanLocalStorage(){
    let page = $('.page');
    if (page.data('action') && page.data('action').indexOf('Cart') !== -1) {
        window.localStorage.removeItem('contactLensSpecialistValue');
    }
}

function triggerSelectStore() {
    let page = $('.page');
    let cartPage = $('.cart-page');
    if (page.data('action') && page.data('action').indexOf('Cart') !== -1 && cartPage && cartPage.data('is-flow-store')
        && cartPage.data('contact-len-specialist')) {
        $('#select-local-store').trigger('change');
        window.localStorage.setItem('contactLensSpecialistValue',cartPage.data('contact-len-specialist'));
    }
}

// select-local-store
$('#select-local-store').change(function () {
    window.localStorage.setItem('storeValue',$(this).find('option:selected').val());
    $.ajax({
        url: $(this).attr('data-action') +'?storeID='+ $(this).find('option:selected').val(),
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            $('#container-contractors').empty().append(data.template);
            if (!data.showFirstOption) {
                window.localStorage.setItem('contactLensSpecialistValue',$('#select-contact-subscription').find('option:selected').val());
            }
        }
    })

});

// Toggle class
$('.cart-page .product-info .sub-element-sub-title').each(function(){
    $(this).click(function(){
        $(this).parent('.sub-element').toggleClass("open");
    });
})
$('.cart-page .product-info .toggle .icon-toggle').each(function(){
    $(this).click(function(){
        $(this).parent().toggleClass("toggle-close");
    });
})

// Select contact store
$('#container-contractors').on('change','#select-contact-subscription',function () {
    window.localStorage.setItem('contactLensSpecialistValue',$(this).find('option:selected').val());
});

/**
 *
 * @param {string} uuid id pli type subscritpion to delete
 */
function deleteSubscriptionDetails(uuid) {
    let subscriptionDetails = $('.uuid-' + uuid).next();
    let subscriptionDConditions = subscriptionDetails.next();

    if (subscriptionDetails.hasClass( "container-detail-subscription" )) {
        subscriptionDetails.remove();
    }

    if (subscriptionDConditions.hasClass( "container-condition-subscriptions" )) {
        subscriptionDConditions.remove();
    }
}

function updateShippingLabels(data) {
    const shippingMsgContainerPickup = $('.shipping-msg-container.pickup-msg');
    const shippingLabels = data.shippingLabels;
    const storePickupShippingLabels = data.storePickupShippingLabels;

    const $shippingMsgContainer = $('.js-shipping-msj .shipping-msg-container');
    const $shippingTemplateContainer = $('.js-shipping-msj-template');

    if (shippingLabels && shippingLabels.enabled) {
        $shippingMsgContainer.empty();

        Object.keys(shippingLabels).forEach(shippingLabel => {
            if(shippingLabel === 'enabled') return
            const currentLabelApply = shippingLabels[shippingLabel];

            if(currentLabelApply) {
                const $shippingLabel = $shippingTemplateContainer.find(`.${shippingLabel}`).first()
                
                const $label = $('<span>').addClass('msj').html($shippingLabel);
                $shippingMsgContainer.append($label)
            }
        });
    }
    
    if(storePickupShippingLabels && storePickupShippingLabels.length > 0) {
        shippingMsgContainerPickup.empty();
        storePickupShippingLabels.forEach(label => {
            const span = $('<span>').addClass('msj').html(label);
            shippingMsgContainerPickup.append(span);
        });
    }
}

/**
 * Show an error notification when there is an error trying to update contact lens especialist
 * data in checkout process
 */
function showContactLensErrorMessage() {
    const errorContainer = $('#data-contact-lens');
    const errorData = errorContainer.length === 1 ? errorContainer.data('contact-lens-error') : null;

    if (errorData && errorData.error && errorData.message) {
        createErrorNotification(errorData.message);
    }
}


function showToastMessage(isError, message) {
    let messageType = isError ? 'alert-danger' : 'alert-success';

    if ($('.add-to-cart-messages').length === 0) {
        $('body').append(
            '<div class="add-to-cart-messages"></div>'
        );
    }

    $('.add-to-cart-messages').append(
        '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
        + message
        + '</div>'
    );

    setTimeout(function () {
        $('.add-to-basket-alert').remove();
    }, 5000);
}


module.exports = {
    cart :  function () {
    showContactLensErrorMessage();
    initSptTermsScroll();

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                showMCasePromo(data.showModalCase);
                if (data.basket.items.length === 0) {
                    $('.cart').empty().append('<div class="row"> ' +
                        '<div class="col-12 text-center"> ' +
                        '<h1>' + data.basket.resources.emptyCartMsg + '</h1> ' +
                        '</div> ' +
                        '</div>'
                    );
                    $('.cart').removeClass('cart-page').addClass('cart-empty');
                    $('.cart-header').find('.subtotal-header-container').empty();
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            deleteSubscriptionDetails(data.toBeDeletedUUIDs[0]);
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    deleteSubscriptionDetails(uuid);

                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.couponsHtml);
                    $('.display-discount-container').empty().append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateShippingLabels(data);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');
        $('.alert-danger').hide();

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.couponsHtml);
                $('.display-discount-container').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error: function (err) {
                $('#termsandconditionscart').data('cart-has-error', true);
                $('.checkout-continue').find('.checkout-btn').addClass('disabled');


                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.couponsHtml);
                    $('.display-discount-container').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    function disableBtnCoupon() {
        promoCodeBtn.addClass('disabled-custom');
        disabledCustom.attr('disabled',true);
    }

    function enableBtnCoupon() {
        disabledCustom.attr('disabled',false);
        promoCodeBtn.removeClass('disabled-custom');
        couponField.removeClass('coupon-code-field-custom-error is-invalid');
        couponError.removeClass('coupon-error');
        circleWarning.hide();
        couponErrorMsj.empty();
    }

    $('#couponCode').on('keyup',function (e) {
        if ($(this).val().length > 0) {
            enableBtnCoupon();
        } else {
            disableBtnCoupon()
        }

    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        couponMissing.hide();
        enableBtnCoupon();
        if (!couponField.val()) {
            promoCodeForm.addClass('is-invalid');
            promoCodeForm.attr('aria-describedby', 'missingCouponCode');
            couponError.addClass('coupon-error');
            circleWarning.show();
            couponMissing.show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        promoCodeForm.removeClass('is-invalid');
        couponErrorMsj.empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    promoCodeForm.addClass('is-invalid');
                    promoCodeForm.attr('aria-describedby', 'invalidCouponCode');
                    couponError.addClass('coupon-error');
                    disableBtnCoupon();
                    couponField.addClass('coupon-code-field-custom-error');
                    circleWarning.show();
                    couponErrorMsj.empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                } else {
                    couponField.removeClass('coupon-code-field-custom-error');
                    $('.coupons-and-promos').empty().append(data.totals.couponsHtml);
                    $('.display-discount-container').empty().append(data.totals.discountsHtml);
                    disableBtnCoupon();
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                    couponField.val('');
                }

                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $('.display-discount-container').empty().append(data.totals.discountsHtml);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.couponsHtml);
                    $('.display-discount-container').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $(document).on('click', 'button.btn.confirm', function (e) {
        const pdpHelpers = require('./../product/pdpHelpers');
        const recetaHelpers = require('./../product/recetaHelpers');
        const activeTabSelector = pdpHelpers.resolveActiveTabSelector();

        let updateLineItemRecipeUrl;
        let lineItemId;
        let lineItemUUID;
        let lineItemEye;
        
        if ($('.subscription-pdp .repite-receta-button').attr('aria-expanded') === 'true') {
            return;
        }

        if(!recetaHelpers.canBeAddedToCart()) {
            alert($('.alert .warning').html());
            return;
        }

        $(activeTabSelector).spinner().start();

        lineItemId = $(this).data('lineitemId');
        lineItemUUID = $(this).data('lineitemUuid');
        lineItemEye = $(this).data('lineitemEye');

        updateLineItemRecipeUrl = $(this).data('updateLineitemRecipeUrl');

        let recetUrl = $(activeTabSelector + ' [data-url-receta]').val();

        let ejeDerContacto = $(activeTabSelector + ' .selecciona-axis-right').val();
        let diametroDerContacto = $(activeTabSelector + ' .selecciona-dmtr-right').val();
        let curvaturaDerContacto = $(activeTabSelector + ' .selecciona-crvt-right').val();
        let AddDerContacto = $(activeTabSelector + ' .selecciona-adds-right').val();
        let sphDerContacto = $(activeTabSelector + ' .selecciona-sph-right').val();
        let cylDerContacto = $(activeTabSelector + ' .selecciona-cyl-right').val();

        let dataRecetaContacto = {};
        dataRecetaContacto['ojo' + lineItemEye] = {};

        let form = {
            lineItemId,
            lineItemUUID
        };

        if(recetUrl !== undefined){
            form.recetUrl= recetUrl;
        }

        if(ejeDerContacto) {
            dataRecetaContacto['ojo' + lineItemEye].eje = ejeDerContacto;
        }
        if(diametroDerContacto) {
            dataRecetaContacto['ojo' + lineItemEye].diametro = diametroDerContacto;
        }
        if(curvaturaDerContacto) {
            dataRecetaContacto['ojo' + lineItemEye].curvatura = curvaturaDerContacto;
        }
        if(AddDerContacto) {
            dataRecetaContacto['ojo' + lineItemEye].Add = AddDerContacto;
        }
        if(sphDerContacto) {
            dataRecetaContacto['ojo' + lineItemEye].sph = sphDerContacto;
        }
        if(cylDerContacto) {
            dataRecetaContacto['ojo' + lineItemEye].cyl = cylDerContacto;
        }

        dataRecetaContacto['ojo' + lineItemEye].ojo = lineItemEye;
        form.dataRecetaContacto = JSON.stringify(dataRecetaContacto);

        let successMessage = $(this).data('successMessage');
        let errorMessage = $(this).data('errorMessage');

        if (updateLineItemRecipeUrl) {
            $.ajax({
                url: updateLineItemRecipeUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    $.spinner().stop();
                    if(data.error) {
                        showToastMessage(true, errorMessage);
                    } else {
                        showToastMessage(false, successMessage);
                    }

                    $('#editRecipe-' + lineItemUUID).attr('data-reset-form', "false");
                    $('#modalGlobalRyk.show').modal('hide');

                    if ($('.modal-backdrop').is(':visible')) {
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                    };

                    if (data.editRecipeRendered) {
                        $('#editRecipeModal-' + lineItemUUID).empty().append(data.editRecipeRendered);
                    }

                    if (data.contactLensDetailsRendered) {
                        $('.contactLensDetails-' + lineItemUUID).each(function( index ) {
                            $(this).empty().append(data.contactLensDetailsRendered);
                        });
                    }

                    //workaround for the scroll bar, it's falling after close the modal
                    $('body').css({
                        overflow: 'visible'
                    });
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    $(document).on('hide.bs.modal', '#modalGlobalRyk', function (e) {
        let btnCancel = $(this).find('button.btn.cancel');

        if (btnCancel) {
            let lineItemUUID = btnCancel.data('lineitemUuid');

            if(lineItemUUID && $('#editRecipe-' + lineItemUUID).attr('data-reset-form') === 'true') {
                let form = $('#recetaForm-' + lineItemUUID);

                if(form) {
                    form[0].reset();
                    form.find("#carga-receta-"+lineItemUUID).val('');
                    form.find("#urlReceta-"+lineItemUUID).val('');
                    let span = form.find('#receta-file-name span');
                    span.text(span.data("placeholder"));
                    $(".add-to-cart-ryk").prop("disabled", true);
                }
            }
        }
    });

    $(".info-icon").on("click", function () {
        const $this = $(this);
        $this.addClass("active");
        setTimeout(function () {
            $this.removeClass("active");
        }, 2000);
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
},
updateCartTotals : updateCartTotals
};


function showSubscriptionsTermsModal()  {
    $('.cart.cart-page #subscriptionTermsModal').modal();
}

function hideSubscriptionsTermsModal() {
    $('#subscriptionTermsModal').hide();
}

function acceptSubscriptionModal() {
    $('#termsandconditionscart').prop('checked', true);
    $('#termsandconditionscart').change();
}

function initSptTermsScroll(){
    const sptModal = document.querySelector('.spt-terms-modal');
    
    if(!sptModal) {
        return;
    }
    const sptModalLastElement = document.querySelector('.spt-term-conditions-content .content-asset > :last-child');

    if(!sptModalLastElement) {
        return;
    }
    
    const options = {
        root: null, 
        rootMargin: '0px',
        threshold: 1
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                $('.spt-terms-modal').find('.confirm').prop('disabled', false);
            }else {
                $('.spt-terms-modal').find('.confirm').prop('disabled', true);
            }
        });
    }, options);

    observer.observe(sptModalLastElement);
}

$(function () {
    const $termsContainer = $("#termsAndConditionsModalContent");
    const $acceptButton = $("#termsAndConditionsModalAccept");
    const $modalContentEnd = $("#subscriptionTermsAndConditionsEnd");
    $acceptButton.prop("disabled", true);

    let observer;
  
    const callback = (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                $acceptButton.prop("disabled", false);
                observer.disconnect(); // Cleanup
                observer = null;
            }
        })
    }
    
    observer = new IntersectionObserver(
        callback,
        {
            root: $termsContainer[0],
            rootMargin: '0px',
            threshold: 0
        }
    );

    const element = $modalContentEnd[0]

    if(element) {
        observer.observe(element);
    }
});